import './actions.scss'

import {wrap} from '@codeurs/front'
import React, {FunctionComponent, useState} from 'react'
import {style} from 'util/campagne/style'
import {Layout} from 'views/campagne/layout'
import {
	ActionCard,
	ActionCardType
} from 'views/campagne/partials/actions/actioncard'
import {ActionsOverview} from 'views/campagne/partials/actions/actionsoverview'
import {BannerCta} from 'views/campagne/partials/banner'
import {CtaRegisterType} from 'views/campagne/partials/ctaregister'
import {Theme} from 'views/campagne/theme'

const styles = style('actions')

export type ActionsType = {
	title: string
	actions: Array<ActionCardType>
	cta: CtaRegisterType
}

export const Actions: FunctionComponent<ActionsType> = wrap(Layout)(
	({actions, banner, cta, categories}) => {
		return (
			<div class={styles}>
				<div class={styles('overview')}>
					<ActionsOverview
						actions={actions}
						cta={cta}
						categories={categories}
					/>
				</div>
				<div class={styles('banner')}>
					<Theme.Container>
						<BannerCta
							headingLeft={banner.title1}
							headingRight={banner.title2}
							description={banner.text}
							ctaLink={banner.link}
							{...banner}
						/>
					</Theme.Container>
				</div>
			</div>
		)
	}
)
